import { Application } from "./application";
import { ApplicationFeature } from "./application-feature";

export function generateKey(item: Application | ApplicationFeature): string {
  return item.name
    .split(" ")
    .map((word: string) => word.toUpperCase())
    .join("_");
}
